export enum UrlParams {
	Allergen = 'al',
	BaseIngredient = 'bi',
	Categories = 'cat',
	Characteristics = 'chr',
	Co2Label = 'co2Lbls',
	NutriScoreLabels = 'nsl',
	PageIndex = 'pi',
	PageSize = 'ps',
	SearchTerm = 'st',
	Seasons = 'sea',
	ShowOnlyDeleted = 'sd',
	Slider = 'sl',
	SortOrder = 'so',
	Tags = 'tag',
}
